var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrongbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 18.3337H12.5C16.6667 18.3337 18.3333 16.667 18.3333 12.5003V7.50033C18.3333 3.33366 16.6667 1.66699 12.5 1.66699H7.50001C3.33334 1.66699 1.66667 3.33366 1.66667 7.50033V12.5003C1.66667 16.667 3.33334 18.3337 7.50001 18.3337Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9593 9.09214C11.8759 9.6838 11.5259 10.1838 11.0426 10.4838V12.1338C11.0426 12.7088 10.5759 13.1755 10.0009 13.1755C9.42592 13.1755 8.95925 12.7088 8.95925 12.1338V10.4838C8.47592 10.1838 8.12591 9.6838 8.04258 9.09214C8.02591 9.00047 8.01758 8.90046 8.01758 8.80046C8.01758 7.5338 9.21759 6.55047 10.5343 6.90047C11.2009 7.07547 11.7426 7.61714 11.9176 8.2838C11.9926 8.5588 12.0009 8.8338 11.9593 9.09214Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 9.09216H11.9596",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04167 9.09204H1.66667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrongbox);
export default __webpack_public_path__ + "static/media/strongbox.3fd48e5c5cb8e8a8e9cbded2b907ed6b.svg";
export { ForwardRef as ReactComponent };